// Add click event listeners to all hotspot triggers
document.querySelectorAll('.hotspot-image__hotspot-trigger').forEach(trigger => {
  trigger.addEventListener('click', function(e) {    
    // Find the parent hotspot element
    const hotspot = this.closest('.hotspot-image__hotspot');
    
    if (hotspot) {
      // Toggle the active class
      hotspot.classList.toggle('hotspot-image__hotspot--active');
    }
  });
});

// Close hotspots when clicking outside
document.addEventListener('click', function(e) {
  // Check if the click is outside any hotspot
  if (!e.target.closest('.hotspot-image__hotspot')) {
    // Remove active class from all hotspots
    document.querySelectorAll('.hotspot-image__hotspot.hotspot-image__hotspot--active').forEach(hotspot => {
      hotspot.classList.remove('hotspot-image__hotspot--active');
    });
  }
});

// Reorganize images into proper columns
function organizeColumns() {
  document.querySelectorAll('.hotspot-image__columns').forEach(container => {
    const images = Array.from(container.querySelectorAll('.image-block__wrapper'));
    
    if (images.length === 0) return;
    
    // Create column containers
    const leftColumn = document.querySelector('.hotspot-image__column--left');
    const rightColumn = document.querySelector('.hotspot-image__column--right');

    // Sort images into columns
    images.forEach(img => {
      const column = img.getAttribute('data-column');
      if (column === 'right-column') {
        rightColumn.appendChild(img);
      } else {
        leftColumn.appendChild(img);
      }
    });
    
    // Clear container and add columns
    container.innerHTML = '';
    container.appendChild(leftColumn);
    container.appendChild(rightColumn);
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', organizeColumns);

// Run in theme editor after changes are made
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('.hotspot-image')) {
    organizeColumns();
  }
});